<template>
    <transition name="slide-fade" >
        <div  id="academicsHolder" >
            <div class="uk-child-width-1-1" uk-grid>
                <div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
                    <div class="uk-container uk-container-small ">
                        <p class="uk-text-center uk-text-lead@l uk-text-large@l">
                            Yes you, we want you in our family let us help get you comfortable.
                        </p>
                    </div>
                </div>

                <div class="uk-padding uk-margin-remove-top">
                    <h1 class="uk-heading-line uk-text-center specHeading"><span>Arrange a visit</span></h1>
                    <div class="uk-container uk-container-small ">
                        <div class="uk-child-width-1-2@m" uk-grid>
                            <!-- <div>
                               <img src="../../assets/visitus.jpg" alt="">

                             </div>-->
                            <div>
                                <p class="uk-text-small">
                                    <span class="uk-visible@m"><br><br><br></span>
                                    Arranging a visit is an excellent way to get to know the campus the surrounding and even get to meet future colleagues and instructors.
                                    <br><br>
                                    The warm atmosphere that you will enjoy while your visit is just the beginning of your experience.
                                </p>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="uk-padding uk-background-muted uk-margin-remove-top">
                    <h1 class="uk-heading-line uk-text-center specHeading">Coming on your own?</h1>
                    <div class="uk-container uk-container-small ">
                        <div class="uk-child-width-1-2@m" uk-grid>

                            <div>
                                <h3 class="uk-heading-bullet specHeading">Let us lend a helping hand</h3>
                                <p class="uk-text-small">
                                    The location of all our institutions are located on our <router-link to="/contactus" class="uk-button-link">Contact us</router-link>
                                    page.

                                    <br><br>
                                    Wherever you are, whichever campus you wish to visit, this will give you the full picture of how to get there.
                                </p>

                                <div class="uk-align-right">
                                    <a href="#" class="uk-button uk-button-default">Learn More..</a>
                                </div>
                            </div>
                            <!--<div>
                              <img src="../../assets/onmyown.jpeg" alt="">

                            </div>-->
                        </div>

                    </div>
                </div>

                <div class="uk-padding  uk-margin-remove-top">
                    <h1 class="uk-heading-line uk-text-center specHeading">Visit and be involved</h1>
                    <div class="uk-container uk-container-small ">
                        <div class="uk-child-width-1-2@m" uk-grid>

                            <div>
                                <p class="uk-text-small">
                                    You are welcome to visit us any time, however, if you want to be involved in an experience or event then you can chose to have us help to
                                    co-ordinate.

                                    <br><br>

                                    This will give you a taste of your first experience on your way to becoming apart of our family.
                                </p>

                                <div class="uk-align-right">
                                    <router-link to="/contactus" class="uk-button uk-button-default">Contact us ..</router-link>
                                </div>
                            </div>
                            <!--<div>
                              <img src="../../assets/celeb.jpg" alt="">

                            </div>-->
                        </div>

                    </div>
                </div>

                <!-- <div class="uk-padding uk-background-muted uk-margin-remove-top">
                   <h1 class="uk-heading-line uk-text-center specHeading">Graduates Stories</h1>
                   <div class="uk-container uk-container-small ">
                     <div class="uk-child-width-1-2@m" uk-grid>
                       <div>
                         <img src="../../assets/graduate.jpg" alt="">

                       </div>
                       <div>
                         <h3 class="uk-heading-bullet specHeading">Get inspiration from graduates in the field.</h3>
                         <p class="uk-text-small">
                           Our graduates that have gone on to be successful in their field but behind it there is always a story to be told.
                           <br><br>
                           The stories of these graduates are here to serve as inspiration for current and future students.
                         </p>

                         <div class="uk-align-right">
                           <br>
                           <a href="#" class="uk-button uk-button-default">Read Stories</a>
                         </div>
                       </div>

                     </div>

                   </div>
                 </div>-->



            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "arrangevisit",
        mounted(){
            window.scrollTo(0, 0);
        }
    }
</script>

<style scoped>
    @media screen and (max-width:600px){


        h1{
            font-size: 1.3em !important;
        }
        h3{
            font-size: 1.1em !important;
        }
        p,li{
            font-size: 0.8em !important;
        }


    }
</style>
